var map = {
	"./en/common.json": 21866,
	"./en/home.json": 79028,
	"./en/login.json": 53908,
	"./en/macro.json": 56785,
	"./en/micro.json": 86985,
	"./en/productConfiguration.json": 99180,
	"./en/toolConfiguration.json": 10905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50801;